<template>
  <div class="pdfLink">
    <pdfLink
      :href="'https://finmoll.ru/backend/content/documents/certificate_ooo_finmoll'"
      :title="'Свидетельство ООО МКК «ФИНМОЛЛ»'"
    ></pdfLink>
    <pdfLink
      :href="'https://finmoll.ru/backend/content/documents/certificate_sro_mir'"
      :title="'Свидетельство членства СРО МИР'"
    ></pdfLink>
    <a href=""></a>
  </div>
</template>

<script>
  export default {
    name: "Testimonies",
    components: {
      pdfLink: () => import('@/components/chunk/pdfLink'),
    }
  }
</script>

<style scoped>

</style>
